<template>
    <Transition name="vertical-nav-app-title">
        <h1 class="app-logo-title">
            <span class="text-blue">Stat</span>
            <span class="text-success">DB</span>
            <span class="text-gray">s</span>
        </h1>
    </Transition>
</template>
